import jwtDecode from 'jwt-decode';
import { IStorageProvider } from '../storage/IStorageProvider';
import { STORAGE_KEYS } from '../constants/storage';

export interface DecodedToken {
  exp?: number;
  [key: string]: any;
}

export class TokenHelper {
  /**
   * Decodes a JWT token.
   * @param token The JWT string.
   * @returns Decoded payload or null if invalid.
   */
  static decodeJwt<T = DecodedToken>(token: string): T | null {
    try {
      if (!token) return null;
      return jwtDecode(token) as T;
    } catch (error) {
      console.error('Failed to decode JWT:', error);
      return null;
    }
  }

  /**
   * Checks if a JWT token is expired.
   * @param token The JWT string.
   * @param bufferSeconds Number of seconds before actual expiry to treat as expired.
   * @returns True if expired or invalid.
   */
  static isExpired(token: string, bufferSeconds: number = 30): boolean {
    const decoded = this.decodeJwt(token);
    if (!decoded || !decoded.exp) return true;

    const expirationTimeMs = decoded.exp * 1000;
    const currentTimeMs = Date.now();
    const bufferMs = bufferSeconds * 1000;

    return currentTimeMs >= (expirationTimeMs - bufferMs);
  }

  /**
   * Removes all authentication tokens and state from storage.
   * @param storage The storage provider.
   */
  static removeTokens(storage: IStorageProvider): void {
    storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
    storage.remove(STORAGE_KEYS.AUTH_STATE);
    storage.remove(STORAGE_KEYS.AUTH_REDIRECT_URI);
    storage.remove(STORAGE_KEYS.AUTH_VERIFIER);
  }
}
